import script from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./InfoModal.vue?vue&type=style&index=0&id=4fd00c46&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd00c46"]])

export default __exports__